import { z } from 'zod'

export const JobActionValidationErrorSchema = z.object({
  errorType: z.string().default(''),
  detailedError: z.string().default(''),
})

/** One persisted action in job_audits.job_actions JSONB. */
export const JobActionSchema = z.object({
  pnpWorkerId: z.string(),
  actionTime: z.string(),
  action: z.string(),
  barcode: z.string(),
  productType: z.string(),
  productVariantId: z.string().optional(),
  /** Authoritative server receive time when present; prefer over actionTime for ordering. */
  receivedAtUtc: z.string().optional(),
  /** Camera results only. A record with no source came from the barcode scanner. */
  source: z.literal('camera').optional(),
  /** Scan attempts at a station with a camera only: whether its stream was open at that moment. */
  cameraConnected: z.boolean().optional(),
  validationError: JobActionValidationErrorSchema.default({ errorType: '', detailedError: '' }),
})

export type JobAction = z.infer<typeof JobActionSchema>
